module.exports = __webpack_public_path__ + "static/media/CryptoWorldCup.2064f750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/BlockChain/CryptoWorldCup.png
// module id = 480
// module chunks = 0